export const CODE_GROUP_LIFE_CYCLE_STATUS = {
  DRAFT: "DRAFT",
  QUEUED: "QUEUED",
  IN_PROGRESS: "IN_PROGRESS",
  GENERATED: "GENERATED",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  EXPIRED: "EXPIRED",
};

export const CODE_GROUP_LIFE_CYCLE_PTR_STATUS = {
  QUEUED: "QUEUED",
  IN_PROGRESS: "IN_PROGRESS",
  GENERATED: "GENERATED",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  EXPIRED: "EXPIRED",
};

export const CODE_GROUP_ADMINISTRATION_STATUS = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
};

export const CODE_GROUP_CATEGORY = {
  DEFAULT: "DEFAULT",
  SUPPORT: "SUPPORT",
};

export const CODE_GROUP_CREATION_TYPE = {
  PRE_GENERATED: "PRE_GENERATED",
  SYSTEM_GENERATED: "SYSTEM_GENERATED",
};

export const CODE_GROUP_CREATION_TYPE_LABELS = {
  SYSTEM_GENERATED: "Generated",
  PRE_GENERATED: "Uploaded",
};

export const PRODUCER_COMPANIES = {
  HAS: "HAS",
  BERICAP: "BERICAP",
  PROPAK: "PROPAK",
  BALL: "BALL",
  CROWN: "CROWN",
};

export const PERFORMANCES_ACTIVITY_TYPES = [
  { key: "code-scan", value: "Code Scan" },
  { key: "code-scan-generic", value: "Code Scan Generic" },
  { key: "package-scan", value: "Package Scan" },
  { key: "receipt-scan", value: "Receipt Scan" },
  { key: "survey", value: "Survey" },
  {
    key: "receipt-scan-complete-points",
    value: "Scan a Receipt Complete Points",
  },
  {
    key: "code-scan-upload-points",
    value: "Scan a Code (Pre Generated)",
  },
  {
    key: "claim-reward",
    value: "Claim Reward",
  },
  {
    key: "check-in",
    value: "Scan QR Code",
  },
  {
    key: "watch-a-video",
    value: "Watch a Video",
  },
  {
    key: "read-an-article",
    value: "Read an Article",
  },
  {
    key: "take-a-survey-mx",
    value: "Take a Survey",
  },
  {
    key: "package-scan-points",
    value: "Scan a Package",
  },
  {
    key: "deeplink-action",
    value: "Deeplink Participation",
  },
  {
    key: "package-scan-no-unique-code-points",
    value: "Scan a Package Without Unique Code",
  },
  {
    key: "registration-generic",
    value: "Registration Generic",
  },
  {
    key: "registration",
    value: "Registration",
  },
  {
    key: "generic",
    value: "Generic",
  },
  {
    key: "complete-profile",
    value: "Complete Profile",
  },
];

export const PERFORMANCES_LIFE_CYCLE_STATUS = [
  { key: "APPROVED", value: "Approved" },
  { key: "AUTO_APPROVED", value: "Auto Approved" },
  { key: "AUTO_REJECTED", value: "Auto Rejected" },
  { key: "COMPLETED", value: "Completed" },
  { key: "FAILED", value: "Failed" },
  { key: "INVALID", value: "Invalid" },
  { key: "PENDING", value: "Pending" },
  { key: "REJECTED", value: "Rejected" },
];

export const PERFORMANCES_CHANNELS = [
  { key: "APP", value: "App" },
  { key: "WEB", value: "Web" },
  { key: "WHATSAPP", value: "Whatsapp" },
];

export const REWARD_REDEMPTION_LIFE_CYCLE_STATUS = {
  APPROVED: "APPROVED",
  NOT_APPROVED: "NOT_APPROVED",
  REJECTED: "REJECTED",
  FULLY_CLAIMED: "FULLY_CLAIMED",
  UNCLAIMED: "UNCLAIMED",
};
export const CUSTOMIZED_REWARDS_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const REWARD_REDEMPTION_CATALOG_TYPE = {
  PROGRAM_REDEMPTION: "PROGRAM_REDEMPTION",
  SINGLE_EXCLUSIVE: "SINGLE_EXCLUSIVE",
  MULTI_EXCLUSIVE: "MULTI_EXCLUSIVE",
};

export const ENTRY_NUMBER_TYPE_MAP = {
  NO_NUMBER: "Number not required",
  RANDOM: "Random",
  RANDOM_UNIQUE: "Random Unique",
  LOTTERY: "Lottery",
};

export const COUNTRY_OPTIONS = [
  {
    id: "CA",
    displayText: "Canada",
  },
  {
    id: "US",
    displayText: "United States of America",
  },
  {
    id: "MX",
    displayText: "Mexico",
  },
  {
    id: "BR",
    displayText: "Brazil",
  },
  {
    id: "GT",
    displayText: "Guatemala",
  },
  {
    id: "SV",
    displayText: "El Salvador",
  },
  {
    id: "HN",
    displayText: "Honduras",
  },
  {
    id: "CR",
    displayText: "Costa Rica",
  },
  {
    id: "PA",
    displayText: "Panama",
  },
  {
    id: "DO",
    displayText: "Dominican Republic",
  },
  {
    id: "PR",
    displayText: "Puerto Rico",
  },
  {
    id: "CO",
    displayText: "Colombia",
  },
  {
    id: "CL",
    displayText: "Chile",
  },
  {
    id: "UY",
    displayText: "Uruguay",
  },
  {
    id: "PY",
    displayText: "Paraguay",
  },
  {
    id: "AR",
    displayText: "Argentina",
  },
  {
    id: "EC",
    displayText: "Ecuador",
  },
  {
    id: "PE",
    displayText: "Peru",
  },
  {
    id: "VE",
    displayText: "Venezuela, Bolivarian Republic of",
  },
  {
    id: "UK",
    displayText: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    id: "FR",
    displayText: "France",
  },
  {
    id: "ES",
    displayText: "Spain",
  },
  {
    id: "NL",
    displayText: "Netherlands, Kingdom of the",
  },
  {
    id: "BE",
    displayText: "Belgium",
  },
  {
    id: "NORD",
    displayText: "Nordics",
  },
  {
    id: "DACH",
    displayText: "Dach",
  },
  {
    id: "PL",
    displayText: "Poland",
  },
  {
    id: "LT",
    displayText: "Lithuania",
  },
  {
    id: "EE",
    displayText: "Estonia",
  },
  {
    id: "LV",
    displayText: "Latvia",
  },
  {
    id: "GR",
    displayText: "Greece",
  },
  {
    id: "CY",
    displayText: "Cyprus",
  },
  {
    id: "RS",
    displayText: "Serbia",
  },
  {
    id: "BA",
    displayText: "Bosnia and Herzegovina",
  },
  {
    id: "SI",
    displayText: "Slovenia",
  },
  {
    id: "HR",
    displayText: "Croatia",
  },
  {
    id: "UA",
    displayText: "Ukraine",
  },
  {
    id: "CZ",
    displayText: "Czechia",
  },
  {
    id: "HU",
    displayText: "Hungary",
  },
  {
    id: "SK",
    displayText: "Slovakia",
  },
  {
    id: "AL",
    displayText: "Albania",
  },
  {
    id: "XK",
    displayText: "Kosovo",
  },
  {
    id: "MK",
    displayText: "North Macedonia",
  },
  {
    id: "ME",
    displayText: "Montenegro",
  },
  {
    id: "IT",
    displayText: "Italy",
  },
  {
    id: "TR",
    displayText: "Turkey",
  },
  {
    id: "PT",
    displayText: "Portugal",
  },
  {
    id: "SA",
    displayText: "Saudi Arabia",
  },
  {
    id: "EG",
    displayText: "Egypt",
  },
  {
    id: "ZA",
    displayText: "South Africa",
  },
  {
    id: "IQ",
    displayText: "Iraq",
  },
  {
    id: "AE",
    displayText: "United Arab Emirates",
  },
  {
    id: "AU",
    displayText: "Australia",
  },
  {
    id: "ID",
    displayText: "Indonesia",
  },
  {
    id: "IL",
    displayText: "Israel",
  },
  {
    id: "BH",
    displayText: "Bahrain",
  },
  {
    id: "JO",
    displayText: "Jordan",
  },
  {
    id: "KW",
    displayText: "Kuwait",
  },
  {
    id: "LB",
    displayText: "Lebanon",
  },
  {
    id: "QA",
    displayText: "Qatar",
  },
  {
    id: "OM",
    displayText: "Oman",
  },
  {
    id: "DE",
    displayText: "Germany",
  },
  {
    id: "FI",
    displayText: "Finland",
  },
  {
    id: "SE",
    displayText: "Sweden",
  },
  {
    id: "DK",
    displayText: "Denmark",
  },
  {
    id: "IS",
    displayText: "Iceland",
  },
  {
    id: "NO",
    displayText: "Norway",
  },
  {
    id: "AT",
    displayText: "Austria",
  },
  {
    id: "BG",
    displayText: "Bulgaria",
  },
  {
    id: "RO",
    displayText: "Romania",
  },
  {
    id: "CH",
    displayText: "Switzerland",
  },
];
